export const APP_NAME = 'DOUBLEM STOCK';

export default function AppName({ className }) {
  return <span className={className}>{APP_NAME}</span>;
}
